import { Module, VuexModule, Mutation, getModule, MutationAction, Action } from 'vuex-module-decorators';
import store from '@/store';
import { Question as QuestionModel } from '@/store/models';
import QuestionService from '@/services/QuestionService';
import { ChoiceModule } from '@/store/modules/Choice';

@Module({
	dynamic: true,
	name: 'question',
	store,
})
class Question extends VuexModule {
	public questions: QuestionModel[] = [];
	public activeQuestion: QuestionModel = {
		id: -1,
		nextQuestionId: -1,
		order: -1,
		surveyId: -1,
		required: false,
		text: '',
		type: ''
	};

	public nextQuestionId: number = this.activeQuestion.nextQuestionId;

	public get percentageCompleted(): number {
		const numberQuestions = this.questions.length;
		const indexActiveQuestion = this.questions.indexOf(this.activeQuestion);
		return (indexActiveQuestion + 1) / numberQuestions * 100;
	}

	@MutationAction
	public async loadQuestions(surveyId: number) {
		const questionsResponse = await QuestionService.getInstance().getQuestions(surveyId);
		const questions: QuestionModel[] = [];

		questionsResponse.forEach( async (response) => {
			questions.push({
				id: response.id,
				surveyId: response.survey_id,
				order: response.order,
				nextQuestionId: response.next_question,
				type: response.type,
				text: response.text,
				required: response.required
			});
		});

		return { questions };
	}

	/**
	 * 
	 * @param questionId Loads question with provided id
	 */
	@Action
	public loadQuestion(questionId: number): Promise<QuestionModel> {
		return new Promise<QuestionModel>((resolve, reject) => {
			// Reset choices to prevent display of choices from previous question
			ChoiceModule.resetChoices();

			// Return question with provided id
			const nextQuestion = this.questions.find((question) => question.id === questionId);
			if (nextQuestion !== undefined) {
				this.updateActiveQuestion(nextQuestion);
			}
			resolve(this.activeQuestion);
		});
	}

	@Action
	public updateActiveQuestion(question: QuestionModel) {
		this.setActiveQuestion(question);
		this.setNextQuestionId(question.nextQuestionId);
	}

	@Mutation
	public setActiveQuestion(question: QuestionModel) {
		this.activeQuestion = question;
	}

	@Mutation
	public setNextQuestionId(nextQuestionId: number) {
		this.nextQuestionId = nextQuestionId;
	}
}

export const QuestionModule = getModule(Question);
